// extracted by mini-css-extract-plugin
export default {"form-item":"Login_form-item__i2qNZ","form-item-label":"Login_form-item-label__TODXZ"};